import { QueryModelCore } from "@/core/model.core";

const { NODE_ENV } = process.env;
const API_PROXY = NODE_ENV === "development" ? "/proxyApi" : ""

export default class Home {
    /**
     * 查询导航栏 code:site_nav
     * 查询 Magic Token code:page1
     * ....
     * @returns {Promise<*>}
     * @param code
     */
    async queryHomePageByCode(code) {
        const result = await new QueryModelCore(`${ API_PROXY }/api/cms/page/${ code }`).get({});
        const { data } = result;
        return data;
    }

    /**
     * 查询订阅套餐
     * @param code
     * @returns {Promise<*>}
     */
    async querySubscriptionPlans(params = {}) {
        const result = await new QueryModelCore(`${ API_PROXY }/api/pricing/subscription-plans`).get(params);
        const { data } = result;
        return data;
    }

    /**
     * 查询Api价格
     * @param code
     * @returns {Promise<*>}
     */
    async queryPricingModels(params = {}) {
        const result = await new QueryModelCore(`${ API_PROXY }/api/pricing/models`).get(params);
        const { data } = result;
        return data;
    }


}